export default __webpack_public_path__ + "static/media/up.344f3a95.svg";